import {
  type MantineStyleProps,
  Text as MantineText,
  type TextProps,
} from "@mantine/core";

type Props = {
  children: React.ReactNode;
  lineBreak?: boolean;
} & MantineStyleProps &
  TextProps;

export function Text(props: Props) {
  const { children, lineBreak, ...textProps } = props;
  const defaultOption: Omit<TextProps, "children"> = {
    fz: "sm",
  };
  const option = Object.assign({}, defaultOption, textProps);

  return (
    <MantineText {...option} style={{ whiteSpace: "pre-wrap" }}>
      {children}
    </MantineText>
  );
}
